import { InsightType } from "@amzn/d16-g-client-deck-builder-typescript-client";
import { Text } from "@amzn/storm-ui";
import React from "react";
import styled from "styled-components";

import { useContentCardShown } from "../../../../hooks/misc/useContentCardShown";
import type { CardDetail } from "../../../../types/card";
import { CardDetailsSource } from "../../../../types/card";
import type { InsightFamilyWithSummary } from "../../../../types/insightFromAI";
import {
    formatFamilyName,
    formatObjectives,
} from "../../../../utils/insightFamilies.utils";
import { CardLayout } from "../insightDetails/CardLayout";

import { InsightFromAICardAction } from "./InsightFromAICardAction";

export interface InsightsFromAICardProps {
    insight: InsightFamilyWithSummary;
    index: number;
    responseId: string;
}

const Content = styled(Text)`
    width: 100%;
    text-align: left;
    box-sizing: border-box;
    background: ${({ theme }) => theme.color.purple[100]};
    border-radius: 0 0 10px 10px;
`;

export const InsightFromAICard: React.FunctionComponent<
    InsightsFromAICardProps
> = ({ insight, index, responseId }) => {
    const { selectedInsightSubtypeIds, insightFamily } = insight;
    const { identifier, browseNode, brand, title, familyName, objectives } =
        insightFamily;
    const insightType = InsightType.G4S;

    useContentCardShown({ identifier, insightType });
    const details: CardDetail[] = [
        {
            label: "Brand",
            value: brand,
        },
        {
            label: "BN",
            value: browseNode,
            lineClamp: 2,
        },
        {
            label: "Family name",
            value: formatFamilyName(familyName),
        },
        {
            label: "Objective",
            value: formatObjectives(objectives),
            renderOn: [CardDetailsSource.SIDEPANEL],
        },
    ];

    return (
        <Content>
            <CardLayout
                description={title ?? ""}
                details={details}
                actions={
                    <InsightFromAICardAction
                        responseId={responseId}
                        identifier={identifier!}
                        selectedInsightSubtypeIds={selectedInsightSubtypeIds}
                        details={details}
                        title={title!}
                        index={index}
                    />
                }
                dataTestId={`${identifier}-card`}
                key={identifier}
                summary={insight.g4sSummary}
            />
        </Content>
    );
};
